module.exports = __webpack_public_path__ + "static/media/charlene.7f011e8c.png";